(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbh-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function ready(fn) {
      if (document.readyState !== 'loading') { fn(); }
      else { document.addEventListener('DOMContentLoaded', fn); }
    }

    ready(function () {
      /* Live countdown. */
      document.querySelectorAll('[data-sbh-countdown]').forEach(function (timer) {
        var endRaw = timer.getAttribute('data-end') || '';
        var target = Date.parse(endRaw.replace(' ', 'T'));

        /* Fallback to a rolling three-day timer if no valid date is set. */
        if (isNaN(target)) {
          target = Date.now() + (3 * 24 * 3600 + 9 * 3600 + 18 * 60) * 1000;
        }

        var d = timer.querySelector('[data-d]'),
            h = timer.querySelector('[data-h]'),
            m = timer.querySelector('[data-m]'),
            s = timer.querySelector('[data-s]');

        function pad(n) { return (n < 10 ? '0' : '') + n; }
        function tick() {
          var diff = Math.max(0, target - Date.now());
          var sec = Math.floor(diff / 1000), dd = Math.floor(sec / 86400); sec -= dd * 86400;
          var hh = Math.floor(sec / 3600); sec -= hh * 3600;
          var mm = Math.floor(sec / 60); sec -= mm * 60;
          if (d) d.textContent = pad(dd);
          if (h) h.textContent = pad(hh);
          if (m) m.textContent = pad(mm);
          if (s) s.textContent = pad(sec);
        }
        tick();
        setInterval(tick, 1000);
      });

      /* Rotating messages. */
      document.querySelectorAll('[data-sbh-rotator]').forEach(function (rot) {
        var msgs = rot.querySelectorAll('.sbh-msg');
        if (msgs.length < 2) { return; }
        var i = 0;
        setInterval(function () {
          msgs[i].classList.remove('sbh-on');
          i = (i + 1) % msgs.length;
          msgs[i].classList.add('sbh-on');
        }, 3200);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbh-collection-list"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function ready(fn){ if(document.readyState!=='loading'){fn()} else {document.addEventListener('DOMContentLoaded',fn)} }
    ready(function(){
      var root=document.querySelector('[data-sbh-clist]');
      if(!root) return;
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
      },{threshold:.12});
      root.querySelectorAll('.sbh-clist__card').forEach(function(c){
        c.style.opacity='0'; c.style.transform='translateY(18px)'; c.style.transition='opacity .6s ease, transform .6s cubic-bezier(.2,.6,.2,1)';
        io.observe(c);
      });
      var style=document.createElement('style');
      style.textContent='.sbh-clist__card.is-in{opacity:1!important;transform:none!important} .sbh-clist__card.is-disabled{opacity:.62!important}';
      document.head.appendChild(style);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbh-collection"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function ready(fn){ if(document.readyState!=='loading'){fn()} else {document.addEventListener('DOMContentLoaded',fn)} }

    ready(function(){
      var root = document.querySelector('[data-sbh-collection]');
      if(!root) return;

      // Wishlist toggle (demo)
      root.querySelectorAll('.sbh-wish').forEach(function(b){
        b.addEventListener('click', function(){ b.classList.toggle('is-on'); });
      });

      // ---- 1. Auto-close other filters when one opens (only one open at a time) ----
      var allDetails = root.querySelectorAll('details.sbh-filter[data-sbh-filter]');
      allDetails.forEach(function(det){
        det.addEventListener('toggle', function(){
          if(det.open){
            allDetails.forEach(function(other){
              if(other!==det && other.open) other.open=false;
            });
          }
        });
      });
      // Close filters when clicking outside
      document.addEventListener('click', function(e){
        if(!e.target.closest('.sbh-coll__filters')){
          allDetails.forEach(function(d){ d.open=false; });
        }
      });

      // ---- 2. Availability & all filters fully functional + realtime ----
      var filterInputs = root.querySelectorAll('[data-sbh-filter-input]');
      filterInputs.forEach(function(inp){
        if(inp.type==='checkbox'){
          inp.addEventListener('change', function(){
            var label = inp.closest('.sbh-filter__opt');
            if(label) label.classList.toggle('is-on', inp.checked);
            // Realtime: apply immediately (no need to click Apply)
            // Small delay to let tick animation show
            setTimeout(function(){ window.location.href = buildFilterURL(); }, 180);
          });
        }
      });

      function buildFilterURL(){
        var url = new URL(window.location.href);
        var sort = url.searchParams.get('sort_by');
        var newParams = new URLSearchParams();
        if(sort) newParams.set('sort_by', sort);
        filterInputs.forEach(function(inp){
          if(inp.type==='checkbox'){
            if(inp.checked){ newParams.append(inp.name, inp.value); }
          } else if(inp.type==='number' && inp.value){
            newParams.set(inp.name, inp.value);
          }
        });
        url.search = newParams.toString();
        return url.toString();
      }

      root.querySelectorAll('[data-sbh-filter-apply]').forEach(function(b){
        b.addEventListener('click', function(){ window.location.href = buildFilterURL(); });
      });
      root.querySelectorAll('[data-sbh-filter-clear]').forEach(function(b){
        b.addEventListener('click', function(){
          var det = b.closest('details');
          if(det){
            det.querySelectorAll('input').forEach(function(i){
              if(i.type==='checkbox'){ i.checked=false; var lb=i.closest('.sbh-filter__opt'); if(lb) lb.classList.remove('is-on'); }
              else i.value='';
            });
          }
        });
      });

      // ---- Quick add — no empty flash, real-time ----
      function getCurrentBadgeCount(){
        var badge = document.querySelector('.sbh-cart .sbh-badge');
        return badge ? parseInt(badge.textContent,10)||0 : 0;
      }
      function setBadge(n){
        n=parseInt(n,10)||0;
        document.querySelectorAll('.sbh-cart').forEach(function(a){
          var b=a.querySelector('.sbh-badge');
          if(n<=0){ if(b) b.remove(); return; }
          if(!b){ b=document.createElement('span'); b.className='sbh-badge'; a.appendChild(b); }
          b.textContent=n;
        });
      }
      function dispatchCartUpdate(promise){
        var ev = new CustomEvent('shopify:cart:lines-update', {bubbles:true});
        try{
          Object.defineProperties(ev, {promise:{value:promise}, action:{value:'add'}, source:{value:'sbh-collection'}});
        }catch(e){ ev.promise=promise; ev.action='add'; }
        document.dispatchEvent(ev);
      }
      function prepareDrawerForAdd(){
        var drawer = document.getElementById('cart-drawer');
        if(!drawer) return;
        try{
          drawer.querySelectorAll('.cart-drawer__empty, .cart__empty, [data-cart-empty]').forEach(function(el){ el.style.display='none'; });
          if(!drawer.querySelector('.sbh-cart-loading-overlay')){
            var overlay = document.createElement('div');
            overlay.className='sbh-cart-loading-overlay';
            overlay.innerHTML='<div class="sbh-cart-spinner" style="width:28px;height:28px;border:2px solid #E9DFC8;border-top-color:#B8893E;border-radius:50%;animation:sbh-spin .8s linear infinite;"></div><span>Adding to cart…</span>';
            overlay.style.cssText='position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;background:rgba(251,248,241,.92);z-index:10;gap:12px;font-size:13px;color:#3E2F1C;backdrop-filter:blur(2px);';
            var inner = drawer.querySelector('.cart-drawer__inner, .theme-drawer__inner, .cart-drawer__content, [data-cart-drawer-inner]') || drawer;
            if(window.getComputedStyle(inner).position==='static') inner.style.position='relative';
            inner.appendChild(overlay);
            if(!document.getElementById('sbh-spin-kf')){
              var st=document.createElement('style'); st.id='sbh-spin-kf';
              st.textContent='@keyframes sbh-spin{to{transform:rotate(360deg)}}';
              document.head.appendChild(st);
            }
          }
        }catch(e){}
      }
      function clearDrawerLoading(){
        var drawer = document.getElementById('cart-drawer');
        if(!drawer) return;
        try{
          var ov = drawer.querySelector('.sbh-cart-loading-overlay');
          if(ov) ov.remove();
          drawer.querySelectorAll('.cart-drawer__empty, .cart__empty, [data-cart-empty]').forEach(function(el){ el.style.display=''; });
        }catch(e){}
      }

      root.querySelectorAll('[data-sbh-quick]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var vid = btn.getAttribute('data-variant-id');
          if(!vid) return;
          var orig = btn.textContent;
          var current = getCurrentBadgeCount();
          btn.disabled=true; btn.textContent='Adding…';
          prepareDrawerForAdd();

          var fd = new FormData(); fd.append('id', vid); fd.append('quantity', 1);
          fetch('/cart/add.js', {method:'POST', body:fd, headers:{'Accept':'application/json'}})
            .then(function(r){ if(!r.ok) return r.json().then(function(j){throw j}); return r.json(); })
            .then(function(){
              return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();});
            })
            .then(function(cart){
              setBadge(cart.item_count);
              var p = Promise.resolve({cart:{totalQuantity:cart.item_count}, detail:{itemCount:cart.item_count}});
              dispatchCartUpdate(p);
              return fetch('/?sections=cart-drawer').then(function(r){ return r.json().catch(function(){ return null; }); }).then(function(sections){
                if(sections && sections['cart-drawer']){
                  var drawer = document.getElementById('cart-drawer');
                  if(drawer){
                    var temp = document.createElement('div');
                    temp.innerHTML = sections['cart-drawer'];
                    var newInner = temp.querySelector('.cart-drawer__inner, .theme-drawer__inner, .cart-drawer__content');
                    var curInner = drawer.querySelector('.cart-drawer__inner, .theme-drawer__inner, .cart-drawer__content');
                    if(newInner && curInner){ curInner.innerHTML = newInner.innerHTML; }
                  }
                }
                return cart;
              }).catch(function(){ return cart; });
            })
            .then(function(){
              var drawer=document.getElementById('cart-drawer');
              if(drawer && typeof drawer.open==='function' && !drawer.hasAttribute('open')){
                try{ drawer.open(); }catch(e){}
              }
              setTimeout(clearDrawerLoading, 650);
              btn.textContent='✓ Added';
              setTimeout(function(){ btn.disabled=false; btn.textContent=orig; }, 1200);
            })
            .catch(function(){
              clearDrawerLoading();
              setBadge(current);
              btn.disabled=false; btn.textContent=orig;
            });
        });
      });

      // Sort
      var sortSel = root.querySelector('[data-sbh-sort-select]');
      if(sortSel){
        sortSel.addEventListener('change', function(){
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sortSel.value);
          window.location.href = url.toString();
        });
      }

      // Chips (demo filter)
      root.querySelectorAll('.sbh-chip[data-chip]').forEach(function(chip){
        chip.addEventListener('click', function(){
          chip.classList.toggle('is-on');
          var q = chip.getAttribute('data-chip').toLowerCase();
          if(!chip.classList.contains('is-on')) q='';
          var grid = root.querySelector('[data-sbh-grid]');
          if(!grid) return;
          grid.querySelectorAll('.sbh-prod').forEach(function(card){
            var t = (card.querySelector('.sbh-prod__title')?.textContent || '').toLowerCase();
            card.style.display = (!q || t.indexOf(q)>-1) ? '' : 'none';
          });
        });
      });

    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbh-header"]) return;
  try {
    
  (function () {
    function ready(fn) {
      if (document.readyState !== 'loading') { fn(); }
      else { document.addEventListener('DOMContentLoaded', fn); }
    }

    ready(function () {
      var header = document.querySelector('[data-sbh-header]');

      // ---- Sticky behaviour engine (scroller-aware: Horizon scrolls .page-wrapper on desktop) ----
      if (header) {
        var mode = header.getAttribute('data-sticky-mode') || 'always';
        var condense = header.getAttribute('data-condense') === '1';
        var btt = document.querySelector('[data-sbh-btt]');
        function detectScroller() {
          var pw = document.querySelector('.page-wrapper');
          if (pw && /(auto|scroll)/.test(window.getComputedStyle(pw).overflowY) && pw.scrollHeight - pw.clientHeight > 4) return pw;
          return null;
        }
        var SCROLLER = detectScroller();
        function getScroll() {
          if (SCROLLER) return SCROLLER.scrollTop;
          return Math.max(window.scrollY || 0, document.documentElement.scrollTop || 0);
        }
        function nearBottom() {
          var y = getScroll();
          if (SCROLLER) return (SCROLLER.scrollHeight - y - SCROLLER.clientHeight) < 90;
          return (document.documentElement.clientHeight - (y + window.innerHeight)) < 90;
        }
        function goTop() {
          var opts = { top: 0, behavior: 'smooth' };
          if (SCROLLER) SCROLLER.scrollTo(opts); else window.scrollTo(opts);
        }
        var lastY = getScroll(), tick = false;
        function stickyUpd() {
          tick = false;
          var y = getScroll();
          // Disable sticky on mobile (<=1080px) per user request
          if (window.innerWidth <= 1080) {
            header.classList.remove('sbh-header--stuck','sbh-header--up','sbh-header--compact');
            if (btt) btt.classList.remove('is-on');
            lastY = y;
            return;
          }
          if (mode !== 'none') {
            header.classList.toggle('sbh-header--stuck', y > 8);
            // compact later (120px) to avoid early jank — smoother feel
            header.classList.toggle('sbh-header--compact', condense && y > 120);
            if (mode === 'smart') {
              // more sensitive threshold, hide after 280px
              if (y > 280 && y > lastY + 2) header.classList.add('sbh-header--up');
              else if (y < lastY - 2 || y <= 280) header.classList.remove('sbh-header--up');
            }
          }
          if (btt) btt.classList.toggle('is-on', y > 520 && !nearBottom());
          lastY = y;
        }
        function onScroll() { if (!tick) { tick = true; requestAnimationFrame(stickyUpd); } }
        // listen to both window (capture catches .page-wrapper) and direct scroller
        window.addEventListener('scroll', onScroll, { passive: true, capture: true });
        if (SCROLLER) SCROLLER.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', function () {
          var newScroller = detectScroller();
          if (newScroller !== SCROLLER) {
            if (SCROLLER) SCROLLER.removeEventListener('scroll', onScroll);
            SCROLLER = newScroller;
            if (SCROLLER) SCROLLER.addEventListener('scroll', onScroll, { passive: true });
          }
          onScroll();
        }, { passive: true });
        stickyUpd();
        if (btt) btt.addEventListener('click', goTop);
      }
      if (!header) return;

      /* Mobile drawer. */
      var drawer = document.querySelector('[data-sbh-drawer]');
      var scrim  = document.querySelector('[data-sbh-scrim]');
      var burger = document.querySelector('[data-sbh-burger]');
      var closer = document.querySelector('[data-sbh-close]');

      function openDrawer() {
        if (drawer) drawer.classList.add('sbh-drawer--open');
        if (scrim) scrim.classList.add('sbh-drawer--open');
        if (burger) burger.setAttribute('aria-expanded', 'true');
      }
      function closeDrawer() {
        if (drawer) drawer.classList.remove('sbh-drawer--open');
        if (scrim) scrim.classList.remove('sbh-drawer--open');
        if (burger) burger.setAttribute('aria-expanded', 'false');
      }
      if (burger) burger.addEventListener('click', openDrawer);
      if (closer) closer.addEventListener('click', closeDrawer);
      if (scrim) scrim.addEventListener('click', closeDrawer);
      if (drawer) {
        drawer.querySelectorAll('a').forEach(function (a) {
          // Don't auto-close parent links that have submenu toggle
          if (a.classList.contains('sbh-drawer__link--parent')) return;
          a.addEventListener('click', closeDrawer);
        });
        // Accordion for Shop Now etc
        drawer.querySelectorAll('[data-drawer-toggle]').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            var group = btn.closest('[data-drawer-group]');
            if (!group) return;
            var isOpen = group.classList.contains('is-open');
            group.classList.toggle('is-open', !isOpen);
            btn.setAttribute('aria-expanded', String(!isOpen));
          });
        });
      }

      /* Predictive search. */
      var search = header.querySelector('[data-sbh-search]');
      if (!search) return;

      var input    = search.querySelector('[data-sbh-input]');
      var panel    = search.querySelector('[data-sbh-panel]');
      var clearBtn = search.querySelector('[data-sbh-clear]');
      var trending = search.querySelector('[data-sbh-trending]');
      var chips    = search.querySelector('[data-sbh-chips]');
      var results  = search.querySelector('[data-sbh-results]');
      var footer   = search.querySelector('[data-sbh-footer]');

      var popular = (header.getAttribute('data-trending') || 'Jewellery Sets,Bracelets,Beaded Collection,Earrings,Anklets')
        .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var timer = null;

      function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
          return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
        });
      }

      chips.innerHTML = popular.map(function (t) {
        return '<button type="button" class="sbh-search__chip" data-q="' + esc(t) + '">' + esc(t) + '</button>';
      }).join('');

      function showTrending() {
        trending.style.display = 'block';
        results.innerHTML = '';
      }

      function render(data) {
        var prods = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        if (!prods.length) {
          results.innerHTML = '<div class="sbh-search__empty">No results — press Enter to search everything.</div>';
          return;
        }
        trending.style.display = 'none';
        var cur = (header.getAttribute('data-currency') || '').trim();
        results.innerHTML = prods.slice(0, 6).map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
          var price = parseFloat(p.price);
          var compareRaw = p.compare_at_price_max || p.compare_at_price_min || p.compare_at_price;
          var compare = compareRaw ? parseFloat(compareRaw) : NaN;
          var was = '';
          var off = '';
          if (!isNaN(compare) && compare > price) {
            was = '<s>' + cur + esc(compareRaw) + '</s>';
            off = '<span class="sbh-search__off">SAVE ' + Math.round((1 - price / compare) * 100) + '%</span>';
          }
          return '<a class="sbh-search__item" href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="' + esc(p.featured_image.alt || p.title) + '">' : '') +
            '<span class="sbh-search__t"><b>' + esc(p.title) + '</b></span>' +
            '<span class="sbh-search__p"><b>' + cur + esc(p.price) + '</b>' + was + off + '</span>' +
          '</a>';
        }).join('');
        footer.style.display = 'flex';
      }

      function fetchSuggest(q) {
        clearTimeout(timer);
        timer = setTimeout(function () {
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
                '&resources[type]=product&resources[limit]=8')
            .then(function (r) { return r.json(); })
            .then(render)
            .catch(function () {});
        }, 220);
      }

      input.addEventListener('input', function () {
        var q = input.value.trim();
        panel.classList.add('sbh-search--open');
        clearBtn.classList.toggle('sbh-search--show', !!q);
        if (!q) { showTrending(); return; }
        fetchSuggest(q);
      });

      input.addEventListener('focus', function () {
        panel.classList.add('sbh-search--open');
        if (!input.value.trim()) showTrending();
      });

      clearBtn.addEventListener('click', function () {
        input.value = '';
        showTrending();
        clearBtn.classList.remove('sbh-search--show');
        input.focus();
      });

      document.addEventListener('click', function (e) {
        if (!search.contains(e.target)) panel.classList.remove('sbh-search--open');
      });

      chips.addEventListener('click', function (e) {
        var c = e.target.closest('[data-q]');
        if (c) {
          var q = c.getAttribute('data-q') || '';
          // Trending tag click → direct search page with auto-enter (user request)
          window.location.href = '/search?q=' + encodeURIComponent(q);
        }
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { panel.classList.remove('sbh-search--open'); input.blur(); }
      });

      // ---- Cart: icon opens Horizon drawer; badge syncs on any cart change ----
      function cartDrawer() {
        var d = document.getElementById('cart-drawer');
        return (d && typeof d.open === 'function') ? d : null;
      }

      Array.prototype.forEach.call(document.querySelectorAll('.sbh-cart'), function (cartBtn) {
        cartBtn.addEventListener('click', function (e) {
          var d = cartDrawer();
          if (d && !d.isOpen && !d.hasAttribute('open')) {
            e.preventDefault();
            d.open();
          }
        });
      });

      function setBadge(n) {
        n = parseInt(n, 10) || 0;
        Array.prototype.forEach.call(document.querySelectorAll('.sbh-cart'), function (a) {
          var b = a.querySelector('.sbh-badge');
          if (n <= 0) { if (b) b.remove(); return; }
          if (!b) {
            b = document.createElement('span');
            b.className = 'sbh-badge';
            a.appendChild(b);
          }
          b.textContent = n;
        });
      }

      function applyCartCount(res) {
        var n = res && res.cart && typeof res.cart.totalQuantity === 'number'
          ? res.cart.totalQuantity
          : (res && res.detail && res.detail.itemCount);
        if (typeof n === 'number') setBadge(n);
      }

      document.addEventListener('shopify:cart:lines-update', function (e) {
        if (e && e.promise && typeof e.promise.then === 'function') {
          e.promise.then(applyCartCount, function () {});
        } else {
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { setBadge(cart.item_count); })
            .catch(function () {});
        }
      });

      // ---- Overlay scrim for the cart drawer (desktop) ----
      var scrim = document.createElement('div');
      scrim.className = 'sbh-drawer-scrim';
      scrim.hidden = true;
      document.body.appendChild(scrim);

      function syncScrim() {
        var drawer = document.getElementById('cart-drawer');
        var on = !!(drawer && drawer.hasAttribute('open') && window.matchMedia('(min-width: 990px)').matches);
        scrim.hidden = !on;
        document.documentElement.classList.toggle('sbh-cart-overlay', on);
      }

      scrim.addEventListener('click', function () {
        var drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.close === 'function') drawer.close();
      });

      // Stay closed after navigation/reload. The theme persists open drawers in
      // sessionStorage and restores them during parse (this is why the drawer
      // reopened after "Continue shopping" on an empty cart). `no-persist` opts
      // the cart drawer out of that mechanism — the theme's own escape hatch.
      var cartDrawerEl = document.getElementById('cart-drawer');
      if (cartDrawerEl) {
        cartDrawerEl.setAttribute('no-persist', '');
        try { sessionStorage.removeItem('theme-drawer-open'); } catch (err) {}
        if (cartDrawerEl.hasAttribute('open')) {
          if (typeof cartDrawerEl.close === 'function') {
            cartDrawerEl.close();
          } else {
            // Not upgraded yet (restore ran pre-module): clear attributes directly.
            cartDrawerEl.removeAttribute('open');
            var dlg = cartDrawerEl.querySelector('dialog');
            if (dlg) dlg.removeAttribute('open');
          }
        }
      }

      document.addEventListener('theme-drawer:open', syncScrim);
      document.addEventListener('theme-drawer:close', syncScrim);
      window.addEventListener('resize', syncScrim);
      syncScrim();

      // ---- Global a11y: focus-visible, Esc to close, aria-live for cart ----
      (function(){
        var style = document.createElement('style');
        style.textContent = '*:focus-visible{outline:2px solid #B8893E; outline-offset:2px}';
        document.head.appendChild(style);

        document.addEventListener('keydown', function(e){
          if(e.key === 'Escape'){
            if(panel) panel.classList.remove('sbh-search--open');
            if(drawer) drawer.classList.remove('sbh-drawer--open');
            if(scrim) scrim.classList.remove('sbh-drawer--open');
            var cd = document.getElementById('cart-drawer');
            if(cd && cd.hasAttribute('open') && typeof cd.close === 'function'){ try{ cd.close(); }catch(_){} }
            if(document.querySelector('.sbh-drawer__scrim')) document.querySelector('.sbh-drawer__scrim').classList.remove('sbh-drawer--open');
          }
        });

        // aria-live for cart badge
        document.querySelectorAll('.sbh-cart').forEach(function(a){
          a.setAttribute('aria-live','polite');
          a.setAttribute('aria-atomic','true');
        });

        // Deduplicate cart empty messages (live preview showed 2x)
        try{
          var empties = document.querySelectorAll('.cart-drawer__empty, .sbh-cart-empty, [data-cart-empty]');
          // Also check for duplicate \"Your cart is empty\" text nodes in same container
          var cartDrawers = document.querySelectorAll('#cart-drawer');
          if(cartDrawers.length > 1){
            for(var i=1;i<cartDrawers.length;i++){ cartDrawers[i].remove(); }
          }
          // If homepage has both drawer and page cart empty, hide page cart when drawer exists
          var pageCart = document.querySelector('main .cart__empty, .cart-empty, #main-cart .cart__empty');
          var drawerEl = document.getElementById('cart-drawer');
          if(pageCart && drawerEl && window.location.pathname === '/'){
            pageCart.style.display = 'none';
          }
        }catch(_){}

        // Wishlist persistence via localStorage
        var WISH_KEY = 'sbh-wishlist';
        function getWishlist(){
          try{ return JSON.parse(localStorage.getItem(WISH_KEY)||'[]'); }catch(e){ return []; }
        }
        function setWishlist(arr){
          try{ localStorage.setItem(WISH_KEY, JSON.stringify(arr)); }catch(e){}
        }
        function isWished(id){
          var list = getWishlist();
          return list.indexOf(id) !== -1;
        }
        function toggleWish(id, btn){
          var list = getWishlist();
          var idx = list.indexOf(id);
          if(idx === -1){ list.push(id); if(btn) btn.classList.add('on'); }
          else { list.splice(idx,1); if(btn) btn.classList.remove('on'); }
          setWishlist(list);
          // Update aria-pressed
          if(btn) btn.setAttribute('aria-pressed', idx===-1 ? 'true' : 'false');
        }
        // Init wish buttons from storage
        document.querySelectorAll('.sbh-prods__wish, .sbh-wish, [data-wishlist-id]').forEach(function(b){
          var pid = b.getAttribute('data-product-id') || b.getAttribute('data-wishlist-id') || b.closest('[data-product-id]')?.getAttribute('data-product-id');
          if(!pid) return;
          if(isWished(pid)){ b.classList.add('on'); b.setAttribute('aria-pressed','true'); }
          b.addEventListener('click', function(e){
            e.preventDefault();
            toggleWish(pid, b);
          });
        });

        // Add data-product-id to wish buttons if missing (best sellers)
        document.querySelectorAll('.sbh-prods__item').forEach(function(item){
          var pid = item.getAttribute('data-product-id') || item.querySelector('[data-product-id]')?.getAttribute('data-product-id');
          var wish = item.querySelector('.sbh-prods__wish');
          if(pid && wish && !wish.getAttribute('data-product-id')){
            wish.setAttribute('data-product-id', pid);
            if(isWished(pid)){ wish.classList.add('on'); wish.setAttribute('aria-pressed','true'); }
          }
        });
      })();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbh-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-sbh-pdp]');
  if(!root || root.dataset.ready) return;
  root.dataset.ready='1';
  var qty = 1;
  var qtyOutput = root.querySelector('[data-qty-output]');
  var qtyWrap = root.querySelector('[data-sbh-qty]');
  var addBtn = root.querySelector('[data-sbh-add]');
  var addedBox = root.querySelector('[data-sbh-added]');
  var priceNow = root.querySelector('[data-sbh-price-now]');
  var priceWas = root.querySelector('[data-sbh-price-was]');
  var priceOff = root.querySelector('[data-sbh-price-off]');
  var stockEl = root.querySelector('[data-sbh-stock]');

  function syncQty(){ if(qtyOutput) qtyOutput.textContent = qty; }
  if(qtyWrap){
    var minus = qtyWrap.querySelector('[data-minus]');
    var plus = qtyWrap.querySelector('[data-plus]');
    if(minus) minus.addEventListener('click', function(){ if(qty>1){ qty--; syncQty(); } });
    if(plus) plus.addEventListener('click', function(){ if(qty<9){ qty++; syncQty(); } });
  }
  syncQty();

  var chips = root.querySelectorAll('[data-variant-id]');
  function updateVariantUI(v){
    if(!v) return;
    if(addBtn){
      addBtn.setAttribute('data-variant-id', v.id);
      addBtn.disabled = !v.available;
      var addText = root.querySelector('[data-sbh-add-text]');
      if(addText){
        var curSym = root.getAttribute('data-currency') || '£';
        addText.innerHTML = v.available ? 'Add to Cart — <span data-sbh-add-price>'+curSym+(v.price/100).toFixed(2)+'</span>' : 'Sold Out';
      }
    }
    if(priceNow){
      var curSym = root.getAttribute('data-currency') || '£';
      priceNow.textContent = curSym + (v.price/100).toFixed(2);
    }
    if(v.compare_at_price && v.compare_at_price > v.price){
      var save = Math.round((1 - v.price / v.compare_at_price)*100);
      if(priceWas){ priceWas.textContent = (root.getAttribute('data-currency')||'£') + (v.compare_at_price/100).toFixed(2); priceWas.hidden=false; }
      if(priceOff){ priceOff.textContent = 'Save '+save+'%'; priceOff.hidden=false; }
    } else {
      if(priceWas) priceWas.hidden=true;
      if(priceOff) priceOff.hidden=true;
    }
    if(stockEl){
      if(!v.available){
        stockEl.textContent='Out of stock';
      } else {
        var inv = (v.inventory_quantity != null && v.inventory_quantity !== '') ? parseInt(v.inventory_quantity,10) : null;
        var manages = v.inventory_management && v.inventory_management !== '' && v.inventory_management !== 'null';
        var vTitle = v.title || v.option1 || '';
        if(manages && inv != null){
          if(inv <= 0){
            stockEl.textContent='Out of stock';
          } else if(inv <= 5){
            stockEl.textContent='Only '+inv+' '+(inv===1?'piece':'pieces')+' of this variant left at this price'+(vTitle ? ' — '+vTitle : '');
          } else {
            stockEl.textContent=inv+' pieces of this variant available at this price'+(vTitle ? ' — '+vTitle : '');
          }
        } else {
          stockEl.textContent='In stock — ready to ship'+(vTitle ? ' — '+vTitle : '');
        }
      }
    }
    var mainImg = root.querySelector('[data-sbh-main-img]');
    if(v.featured_media){
      var mediaId = v.featured_media.id || v.featured_media;
      var thumb = root.querySelector('[data-media-id="'+mediaId+'"]');
      if(thumb && thumb.getAttribute('data-src') && mainImg){ mainImg.src = thumb.getAttribute('data-src'); root.querySelectorAll('.sbh-pdp__thumb').forEach(function(t){ t.classList.toggle('is-active', t===thumb); }); }
    }
  }
  chips.forEach(function(chip){
    chip.addEventListener('click', function(){
      chips.forEach(function(c){ c.classList.remove('is-on'); });
      chip.classList.add('is-on');
      var price = parseInt(chip.getAttribute('data-price'),10);
      var compare = parseInt(chip.getAttribute('data-compare')||'0',10);
      var available = chip.getAttribute('data-available')==='true';
      var mediaId = chip.getAttribute('data-media-id');
      var inv = chip.getAttribute('data-inventory');
      var invManage = chip.getAttribute('data-inventory-management');
      var title = chip.textContent.trim();
      var v = {
        id: chip.getAttribute('data-variant-id'),
        price: price,
        compare_at_price: compare||null,
        available: available,
        inventory_quantity: inv,
        inventory_management: invManage,
        title: title,
        option1: title,
        featured_media: mediaId ? {id: mediaId} : null
      };
      updateVariantUI(v);
    });
  });
  var thumbs = root.querySelectorAll('[data-media-id]');
  var mainImg = root.querySelector('[data-sbh-main-img]');
  thumbs.forEach(function(th){
    th.addEventListener('click', function(){
      if(!mainImg) return;
      var src = th.getAttribute('data-src');
      if(src){ mainImg.src = src; }
      thumbs.forEach(function(t){ t.classList.remove('is-active'); });
      th.classList.add('is-active');
    });
  });
  function setBadge(n){
    n = parseInt(n,10)||0;
    document.querySelectorAll('.sbh-cart').forEach(function(a){
      var b=a.querySelector('.sbh-badge');
      if(n<=0){ if(b) b.remove(); return; }
      if(!b){ b=document.createElement('span'); b.className='sbh-badge'; a.appendChild(b); }
      b.textContent=n;
    });
  }
  function dispatchCartUpdate(promise){
    var ev = new CustomEvent('shopify:cart:lines-update', {bubbles:true});
    try{ Object.defineProperties(ev, {promise:{value:promise}, action:{value:'add'}}); }catch(e){ ev.promise=promise; ev.action='add'; }
    document.dispatchEvent(ev);
  }
  function prepareDrawer(){
    var drawer = document.getElementById('cart-drawer');
    if(!drawer) return;
    try{
      drawer.querySelectorAll('.cart-drawer__empty, .cart__empty, [data-cart-empty]').forEach(function(el){ el.style.display='none'; });
      if(!drawer.querySelector('.sbh-cart-loading-overlay')){
        var overlay = document.createElement('div');
        overlay.className='sbh-cart-loading-overlay';
        overlay.innerHTML='<div style="width:28px;height:28px;border:2px solid #E9DFC8;border-top-color:#B8893E;border-radius:50%;animation:sbh-spin .8s linear infinite;"></div><span>Adding to cart…</span>';
        overlay.style.cssText='position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;background:rgba(251,248,241,.92);z-index:10;gap:12px;font-size:13px;color:#3E2F1C;';
        var inner = drawer.querySelector('.cart-drawer__inner, .theme-drawer__inner, .cart-drawer__content') || drawer;
        if(window.getComputedStyle(inner).position==='static') inner.style.position='relative';
        inner.appendChild(overlay);
        if(!document.getElementById('sbh-spin-kf')){
          var st=document.createElement('style'); st.id='sbh-spin-kf';
          st.textContent='@keyframes sbh-spin{to{transform:rotate(360deg)}}';
          document.head.appendChild(st);
        }
      }
    }catch(e){}
  }
  function clearDrawer(){
    var drawer = document.getElementById('cart-drawer');
    if(!drawer) return;
    try{
      var ov = drawer.querySelector('.sbh-cart-loading-overlay');
      if(ov) ov.remove();
      drawer.querySelectorAll('.cart-drawer__empty, .cart__empty, [data-cart-empty]').forEach(function(el){ el.style.display=''; });
    }catch(e){}
  }
  function addToCart(variantId, quantity, btn){
    if(!variantId) return;
    var originalLabel = btn ? btn.innerHTML : '';
    if(btn){ btn.disabled=true; btn.innerHTML='Adding…'; }
    prepareDrawer();
    var fd = new FormData(); fd.append('id', variantId); fd.append('quantity', quantity);
    fetch('/cart/add.js', {method:'POST', body:fd, headers:{'Accept':'application/json'}})
      .then(function(r){ if(!r.ok) return r.json().then(function(j){throw j}); return r.json(); })
      .then(function(){ return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); })
      .then(function(cart){
        setBadge(cart.item_count);
        var p = Promise.resolve({cart:{totalQuantity:cart.item_count}, detail:{itemCount:cart.item_count}});
        dispatchCartUpdate(p);
        return fetch('/?sections=cart-drawer').then(function(r){ return r.json().catch(function(){ return null; }); }).then(function(sections){
          if(sections && sections['cart-drawer']){
            var drawer = document.getElementById('cart-drawer');
            if(drawer){
              var temp = document.createElement('div'); temp.innerHTML = sections['cart-drawer'];
              var newInner = temp.querySelector('.cart-drawer__inner, .theme-drawer__inner, .cart-drawer__content');
              var curInner = drawer.querySelector('.cart-drawer__inner, .theme-drawer__inner, .cart-drawer__content');
              if(newInner && curInner){ curInner.innerHTML = newInner.innerHTML; }
            }
          }
          return cart;
        }).catch(function(){ return cart; });
      })
      .then(function(){
        var drawer = document.getElementById('cart-drawer');
        if(drawer && typeof drawer.open==='function'){ if(!drawer.hasAttribute('open')){ try{ drawer.open(); }catch(e){} } }
        setTimeout(clearDrawer, 650);
        if(addedBox){ addedBox.hidden=false; setTimeout(function(){ addedBox.hidden=true; }, 4000); }
        if(btn){ btn.innerHTML='✓ Added'; setTimeout(function(){ btn.disabled=false; btn.innerHTML=originalLabel; }, 1400); }
      })
      .catch(function(err){
        console.error('Add to cart failed', err);
        clearDrawer();
        if(btn){ btn.disabled=false; btn.innerHTML=originalLabel; }
      });
  }
  if(addBtn){
    addBtn.addEventListener('click', function(){
      var vid = addBtn.getAttribute('data-variant-id');
      addToCart(vid, qty, addBtn);
    });
  }
  // Wishlist
  root.querySelectorAll('[data-sbh-wish]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      btn.classList.toggle('on');
      var isOn = btn.classList.contains('on');
      btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
